import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import BootstrapTable from "react-bootstrap-table-next";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import API_ENDPOINTS from "../../../../configs/API_ENDPOINTS";
import { textTranslate } from "../../../../utils/i18n";
import ServiceOrderStatusBadge from "./ServiceOrderStatusBadge";

export const getServiceOrderHistoryColumns = () => [
  {
    dataField: "status.slug",
    text: textTranslate("form.status"),
    editable: false,
    formatter: (cell, row) =>
      row.status ? <ServiceOrderStatusBadge status={row.status} dueDate={row.dueDate} completedAt={row.completedAt} /> : null,
  },
  {
    dataField: "createdAt",
    formatter(cell) {
      return <span>{moment(cell).format("LLL")}</span>;
    },
    text: textTranslate("table.created_at"),
    editable: false,
  },
  {
    dataField: "completedAt",
    formatter(cell) {
      return <span>{moment(cell).format("LLL")}</span>;
    },
    text: textTranslate("table.completedAt"),
    editable: false,
  },
  {
    dataField: "notes",
    text: textTranslate("notes"),
    style: { whiteSpace: "pre-wrap", overflowWrap: "anywhere" },
    editable: false,
  },
  {
    dataField: "solutions",
    formatter(cell) {
      return <span>{cell && cell[0] && cell[0].name ? cell[0].name : "n/a"}</span>;
    },
    text: textTranslate("form.solution"),
    editable: false,
  },
  {
    dataField: "_id",
    text: textTranslate("serviceOrder"),
    headerStyle: { whiteSpace: "nowrap" },
    style: { whiteSpace: "nowrap" },
    formatter(cell) {
      return (
        <Link className="font-weight-bold" target="_blank" to={`/orders/service-orders/${cell}/details`}>
          {textTranslate("showServiceOrder")}
        </Link>
      );
    },
    editable: false,
  },
];

const ServiceHistoryModal = ({ device, onClose }) => {
  const [serviceHistory, setServiceHistory] = useState([]);

  useEffect(() => {
    setServiceHistory([]);
    if (!device) return;

    const fetchServiceHistory = async () => {
      try {
        const response = await axios.get(`${API_ENDPOINTS.SERVICE_ORDERS_DEVICE}`.replace("id", device._id));
        setServiceHistory(response.data);
      } catch (error) {
        console.error("Error fetching service history:", error);
      }
    };
    fetchServiceHistory();
  }, [device]);

  const modalColumns = getServiceOrderHistoryColumns().filter((column) => column.dataField !== "completedAt");

  return (
    <Modal isOpen={Boolean(device)} toggle={onClose} size="xl">
      <ModalHeader toggle={onClose}>
        {device?.device}
        {device?.name ? ` – ${device.name}` : ""}
      </ModalHeader>
      <ModalBody>
        <BootstrapTable keyField="_id" data={serviceHistory} columns={modalColumns} striped hover />
      </ModalBody>
      <ModalFooter>
        <Button color="danger" onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ServiceHistoryModal;
